import FormBuilderOb from '@components/FormBuilder/FormBuilder.ob';
import { FormIds } from '@utils/enums/FormIds.enum';
import { usePatientStore } from '@store/patientStore';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { NewPatientSection } from '@components/NewPatientSection/NewPatientSection';
import { MultiplePatientsNavigator } from '@components/MultiplePatientsNavigator/MultiplePatientsNavigator';
import { Helmet } from 'react-helmet';
import { t } from 'i18next';

interface InsuranceProps {
  setEnableButton: (val: boolean) => void;
}

const CustomPage = ({ setEnableButton }: InsuranceProps) => {
  const updatePatient = usePatientStore(state => state.updatePatient);
  const showAddNewPatientFrame = useOnlineBookingStore(
    state => state.showAddPatientFrame,
  );
  const currPatientIndex = useOnlineBookingStore(state => state.currentPatient);
  const patients = usePatientStore(state => state.patients);

  const [listEnableButton, setListEnableButton] = useState<
    Array<boolean | undefined>
  >([]);

  const enableButtonMaster = useMemo(() => {
    return listEnableButton.every(
      enable => (typeof enable === 'boolean' && enable) || enable === undefined,
    );
  }, [listEnableButton]);

  const handleEnableButton = useCallback((index: number, enable: boolean) => {
    setListEnableButton(prev => {
      if (typeof prev[index] !== 'undefined' && prev[index] !== enable) {
        const newVal = [...prev];
        newVal[index] = enable;
        return newVal;
      }
      return prev;
    });
  }, []);

  useEffect(() => {
    setEnableButton(enableButtonMaster);
  }, [enableButtonMaster]);

  useEffect(() => {
    setListEnableButton(patients.map(p => (p ? false : undefined)));
  }, [patients]);

  return (
    <>
      <Helmet>
        <title>{t('wcag.ob_custom_page_title')}</title>
      </Helmet>
      {showAddNewPatientFrame ? (
        <NewPatientSection setEnableButton={setEnableButton} />
      ) : (
        patients && (
          <>
            {patients.map((_, index) => {
              return (
                <FormBuilderOb
                  key={index}
                  formIds={[FormIds.CustomPage]}
                  isVisible={currPatientIndex === index}
                  setEnableButton={enable => handleEnableButton(index, enable)}
                  onUnmount={formData => {
                    updatePatient(index, FormIds.CustomPage, formData);
                  }}
                  patientIndex={index}
                  mykey={`customPage_${index}`}
                />
              );
            })}
            <MultiplePatientsNavigator
              style={{ padding: '0rem 0rem 1.5rem 0rem' }}
            />
          </>
        )
      )}
    </>
  );
};

export default CustomPage;
